import { TBuilding } from "types/building.types";
import DropdownItem from "../../../DropdownItem/DropdownItem";
import { Container } from "./FloorDropdown.styles";
import { ListContainer } from "./FloorDropdown.styles";

type FloorDropdownProps = {
  locationData?: (TBuilding | null)[];
  building?: { name: string; id: string } | null;
  onChange?: (floor: { name: string; id: string } | null) => void;
};

const FloorDropdown: React.FC<FloorDropdownProps> = ({ building, locationData, onChange }) => {
  const sortFloorFunction = (a: any, b: any) => {
    if (a?.name === null && b?.name === null) return 0;

    const numA = parseInt(a?.name ?? "99999") || 99999;
    const numB = parseInt(b?.name ?? "99999") || 99999;

    //* 숫자로 우선 정렬
    if (numA !== numB) return numA - numB;

    //* 숫자가 동일하면 원본 문자열 비교 (알파벳, 한글 등 포함)
    return (a?.name ?? "").localeCompare(b?.name ?? "", "ko-KR", { numeric: true });
  };

  return (
    <Container>
      <ListContainer>
        {building && building.id !== "" && (
          <DropdownItem
            placeholder="전체 층"
            onClick={() => {
              onChange?.({
                name: "전체 층",
                id: "",
              });
            }}
          />
        )}
        {building &&
          locationData
            ?.find((data) => data?.id === building.id)
            ?.floors.sort(sortFloorFunction)
            .map((floor, index) => (
              <DropdownItem
                key={`${building}_${index}`}
                label={floor?.name ?? "기타 (층 미지정)"}
                onClick={() => {
                  onChange?.(floor);
                }}
              />
            ))}
        {building === null && (
          <DropdownItem
            label="기타 (층 미지정)"
            onClick={() => {
              onChange?.(null);
            }}
          />
        )}
      </ListContainer>
    </Container>
  );
};

export default FloorDropdown;
